import {
  DEFAULT_THRESHOLDS,
  LTEL_YEARS_MAX,
  LTEL_YEARS_MIN,
  NEWCOMER_YEARS_MAX,
  NEWCOMER_YEARS_MIN,
  type Thresholds,
} from '../../core/thresholds';

export type YearsForm = { newcomer: number; longTerm: number };

function range(from: number, to: number): number[] {
  return Array.from({ length: to - from + 1 }, (_, i) => from + i);
}

export function yearsFormFrom(values: Pick<Thresholds, 'newcomerMaxYears' | 'ltelMinYears'>): YearsForm {
  return { newcomer: values.newcomerMaxYears, longTerm: values.ltelMinYears - 1 };
}

export function thresholdsFromForm(form: YearsForm, monitoringYears: number): Thresholds {
  return { newcomerMaxYears: form.newcomer, ltelMinYears: form.longTerm + 1, monitoringYears };
}

export const YEARS_DEFAULTS: YearsForm = yearsFormFrom(DEFAULT_THRESHOLDS);
export const NEWCOMER_CHOICES: number[] = range(NEWCOMER_YEARS_MIN, NEWCOMER_YEARS_MAX);
export const LONG_TERM_CHOICES: number[] = range(LTEL_YEARS_MIN - 1, LTEL_YEARS_MAX - 1);

export function yearsDirty(a: YearsForm, b: YearsForm): boolean {
  return a.newcomer !== b.newcomer || a.longTerm !== b.longTerm;
}

export function yearsLabel(n: number): string {
  return `${n} ${n === 1 ? 'year' : 'years'}`;
}

const ORDINALS = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth'];

export function longTermSentence(form: YearsForm, kind: 'defaults' | 'settings'): string {
  const ordinal = ORDINALS[form.longTerm] ?? `${form.longTerm + 1}th`;
  return `With these ${kind}, a student becomes long-term in their ${ordinal} year as an EL.`;
}
